export default __webpack_public_path__ + "static/media/144796.7100e11f.jpg";